import { createRouter } from "@tanstack/react-router"
import type { AuthUser } from "./hooks/useAuth"
import { queryClient } from "./lib/query-client"
import type { TenantState } from "./lib/tenant"
import { routeTree } from "./routeTree.gen"

export interface RouterContext {
  auth: AuthUser | null
  tenant: TenantState
  queryClient: typeof queryClient
}

export const router = createRouter({
  routeTree,
  context: {
    auth: null,
    tenant: { isAdmin: true, product: "lexicanon", branding: null, mcpUrl: null, loading: true },
    queryClient,
  },
  defaultPreloadStaleTime: 0,
})

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router
  }
}
